import React, {PropTypes} from 'react';
import classNames from 'classnames';
import {MAP_CENTER} from '../../../constants/places';
import './AddressMap.less';

const mapRef = 'address-map';
const mapDefaultZoom = 13;

class AddressMap extends React.Component {
  constructor(props) {
    super(props);

    this.renderAddress = this.renderAddress.bind(this);
  }

  componentDidMount() {
    this.map = new google.maps.Map(this.refs[mapRef], {
      center: MAP_CENTER,
      scrollwheel: false,
      zoom: mapDefaultZoom,
      mapTypeControl: false,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_LEFT
      },
      gestureHandling: 'cooperative'
    });

    this.marker = new google.maps.Marker({
      animation: google.maps.Animation.DROP,
      map: this.map
    });

    this.renderAddress(this.props.address);
  }

  componentWillReceiveProps(nextProps) {
    this.renderAddress(nextProps.address);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.className !== nextProps.className;
  }

  renderAddress(address) {
    const {map, marker} = this;

    if (address && address.latLng) {
      const location = address.latLng;
      marker.setPosition(location);
      marker.setVisible(true);
      map.setCenter(location);
      map.setZoom(17);
    }
    else {
      marker.setVisible(false);
      map.setCenter(MAP_CENTER);
      map.setZoom(mapDefaultZoom);
    }
  }

  render () {
    const {className} = this.props;
    const rootClassName = classNames('address-map', className);

    return (
      <figure className={rootClassName} ref={mapRef}/>
    );
  }
}

AddressMap.propTypes = {
  className: PropTypes.string,
  address: PropTypes.object
};

export default AddressMap;



// WEBPACK FOOTER //
// ./src/components/OrderModal/AddressStep/AddressMap.js